import React from 'react';

export function linksWrapping(data, configs) {
    const isInit = typeof data === 'string';
    const [conf] = configs;

    function breakStrWithLinks(text) {
        return text.replace(conf.reg, '_link_').split('_link_');
    }

    function addToResult(res, str, links) {
        res.push(str);

        if (links) {
            let link = links.shift();
            if (link) {
                res.push(
                    <a
                        href={`${conf.type || ''}${link}`}
                        target="_blank"
                        rel="noreferrer"
                        className="live__tag"
                    >
                        {link}
                    </a>
                );
            }
        }
    }

    try {
        let links = null;

        if (isInit) {
            links = data.match(conf.reg);
            data = breakStrWithLinks(data);
            configs = [...configs];
        }

        data = data.reduce((result, substr) => {
            if (isInit) {
                addToResult(result, substr, links);
            } else {
                if (React.isValidElement(substr)) {
                    result.push(substr);
                } else {
                    links = substr.match(conf.reg);
                    const innerLinks = breakStrWithLinks(substr);

                    if (innerLinks.length > 1) {
                        innerLinks.forEach((str) => {
                            addToResult(result, str, links);
                        });
                    } else {
                        result.push(substr);
                    }
                }
            }

            return result;
        }, []);
    } catch (error) {
        const err = new Error(`Error link wrapping func: ${error}`);
        console.error(err);
    }

    configs.shift();

    if (configs.length) {
        return linksWrapping(data, configs);
    }

    return data;
}
